import { autoserialize } from 'cerialize';

export class MiniRider {
  @autoserialize
  id: number;

  @autoserialize
  firstName: string;

  @autoserialize
  lastInitial: string;

  get displayName(): string {
    return (
      this.firstName +
      ' ' +
      this.lastInitial +
      '.'
    );

  }
}
